module.exports = __webpack_public_path__ + "static/media/pin-icon.b59c5a41.svg";